<div class="side-nav-container">
  <div class="navigation-container">
    <div class="logo-container">
      <img
        class="side-nav-logo"
        [src]="environment.cloudFrontUrl + '/brand/TDOT-Logo.png'"
        alt="Tennessee Department of Transportation logo"
        />
        <img
          class="side-nav-logo"
          [src]="environment.cloudFrontUrl + '/brand/I-24-CL-Logo.png'"
          alt="I-24 Southeast Choice Lanes logo"
          />
        </div>
        <div class="scrollable-nav">
          <nav aria-label="Sidebar navigation">
            <ul class="side-nav-menu" role="menu">
              @for (page of pages; track page; let i = $index) {
                <li
                  role="menuitem"
                  tabindex="0"
                  class="side-nav-item"
                  (click)="setPageIndex(i)"
                  (keydown)="handleKeyDown($event, i)"
                  [ngClass]="{ active: pageIndex === i }"
                  >
                  {{ page }}
                </li>
              }
            </ul>
          </nav>
        </div>

        <div class="side-nav-footer">
          <button class="contact-us-button" (click)="onCommentClick()">
            Comment
          </button>
        </div>
      </div>
    </div>
